
/*
    🔥 SUBCONJUNTO SEO

    Nada de esto se define acá: todo sale de AppCompanyConfig.js. Este archivo existe
    para tener el paquete de etiquetas separado del resto de la identidad, así
    _MetaTagsIcons.js escribe en el <head> sin conocer el config entero.
*/

import { APP_COMPANY_CONFIG } from "./AppCompanyConfig";
import { OBJECT_FREEZE_HELPER } from "../../HELPERS/objectFreeze.helper";


export const _SCHEMA = {

    COMPANY_OG_IMAGE: APP_COMPANY_CONFIG.COMPANY_OG_IMAGE, // VIVE EN PUBLIC 
    COMPANY_OG_IMAGE_URL: APP_COMPANY_CONFIG.COMPANY_OG_IMAGE_URL,
    COMPANY_TWITTER_TITLE: APP_COMPANY_CONFIG.COMPANY_TWITTER_TITLE,
    COMPANY_OG_TITLE: APP_COMPANY_CONFIG.COMPANY_OG_TITLE,
    COMPANY_TWITTER_DESCRIPTION: APP_COMPANY_CONFIG.COMPANY_TWITTER_DESCRIPTION,
    COMPANY_OG_DESCRIPTION: APP_COMPANY_CONFIG.COMPANY_OG_DESCRIPTION,

    COMPANY_LANG: APP_COMPANY_CONFIG.COMPANY_LANG,
    COMPANY_LOCALE: APP_COMPANY_CONFIG.COMPANY_LOCALE,
    COMPANY_LOCALE_MANIFEST: APP_COMPANY_CONFIG.COMPANY_LOCALE_MANIFEST,
    COMPANY_THEME_COLOR: APP_COMPANY_CONFIG.COMPANY_THEME_COLOR,
    COMPANY_KEYWORDS: APP_COMPANY_CONFIG.COMPANY_KEYWORDS,
    COMPANY_DESCRIPTION: APP_COMPANY_CONFIG.COMPANY_DESCRIPTION,

};

export const COMPANY_META_TAGS = OBJECT_FREEZE_HELPER.DEEP_FREEZE(_SCHEMA);